module.exports = __webpack_public_path__ + "static/media/Ajustes.c5edc97b.svg";